import { trialRoundDates, mainRoundDates } from '@app/components/shared/StateLabel/Label'

const RulesVN = (event) => {
  return (
    `
      <h2 class="info-about-static__title"><b>Khi nào sẽ diễn ra Olympic?</b></h2>

      <p class="info-about-static__text">
        Olympic diễn ra trong hai vòng: vòng thi thử và vòng thi chính. Kết quả vòng thi thử không ảnh hưởng đến kết quả vòng thi chính.
      </p>

      <p class="info-about-static__text">
        Đối với học sinh từ lớp 1-12, vòng thi Thử và Vòng thi chính sẽ diễn ra vào mùa Thu năm 2022.
      </p>

      <h3 class="info-about-static__pre-title"><b>Hình Thức Tiến Hành</b></h3>
      <p class="info-about-static__text">
        Olympic sẽ diễn ra trên trang web bricsmath.com và hoàn toàn miễn phí cho tất cả những người tham gia. Tất cả những gì cần chỉ là một thiết bị có truy cập Internet. Những bài toán thú vị và tương tác được xây dựng dưới hình thức trò chơi.Bài về logic và trí tưởng tượng không yêu cầu kiến thức chuyên sâu về toán học và đemlạicơ hội để luyện tập giải những bài toán không phải dạng chuẩn. Đề bài được ra bằng tiếng Bồ Đào Nha, Nga, Hindi, Anh, Trung Quốc, Indonesia và Việt Nam.
      </p>

      <h3 class="info-about-static__pre-title"><b>Cách đăng ký dự thi cho học sinh và giáo viên</b></h3>
      <p class="info-about-static__text">
        Giáo viên truy cập vào trang web bricsmath.com, chọn nước, tiếng và lớp. Giáo viên truy cập trang web www.bricsmath.com và đăng ký học sinh trực tuyến. Học sinh có được thông tin đăng nhập và mật khẩu riêng và có thể giải quyết các thao tác trên mọi thiết bị được kết nối với Internet. Công bố và trao giải những người tham gia BRICSMATH.COM + Sau khi kết thúc Olympic, tất cả học sinh sẽ nhận được bằng, sẽ có trong tài khoản cá nhân trên trang web bricsmath.com.
      </p>

      <p class="info-about-static__text">
        Hình thức thi trực tuyến cho phép tất cả trẻ em, không phân biệt trình độ kiến thức, vị trí xã hội và địa lý, tham gia thi Olympic. Do đó, chúng tôi khuyên tất cả học sinh hãy nắm bắt cơ hội này và tham gia vào ngày hội toán quốc tế.
      </p>

      <p class="info-about-static__text">
        Thông tin thêm về cuộc thi có trên trang: <a href="mailto:info@bricsmath.com">info@bricsmath.com</a>
      </p>
    `
  )
}

export default RulesVN
